/* eslint-disable import/order */
import Vue from 'vue';
import VueMq from 'vue-mq';

import App from './App.vue';

import router from './router';
import store from './vuex';
import fb from './firebaseConfig';
import './registerServiceWorker';

import './styles/index.scss';
import '@/modernizr';
import 'focus-visible';

import vuetify from './plugins/vuetify';

Vue.use(VueMq, {
  breakpoints: {
    sm: 600,
    md: 980,
    lg: 1440,
    xl: Infinity,
  },
});

/* eslint-enable import/order */

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
  /^mdc-/,
];

let app;
fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      vuetify,
      render: h => h(App),
    }).$mount('#app');
  }
});
